import { styled } from '@mui/material';
import { PropsWithChildren } from 'react';

export default function WithGlowBackground({ children }: PropsWithChildren) {
    return (
        <Root>
            <GlowLayer>
                <GlowCircle1 />
                <GlowCircle2 />
            </GlowLayer>

            { children }
        </Root>
    );
}

const Root = styled('span')({
    isolation: 'isolate',
    flex: 1,
    display: 'flex'
});

const GlowLayer = styled('div')({
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: -1
});

const GlowCircle = styled('div', {
    shouldForwardProp: (prop) => ![ 'size', 'top', 'left', 'bottom', 'right', 'backgroundColor' ].includes(prop as string)
})({
    position: 'absolute',
    borderRadius: '50%',
    filter: 'blur(40px)',
    opacity: 0.7,
    pointerEvents: 'none',
    zIndex: 0
});

const GlowCircle1 = styled(GlowCircle)(({ theme }) => ({
    width: 380,
    height: 380,
    top: -140,
    left: -120,
    backgroundColor: 'rgba(208, 28, 83, 0.12)',

    [theme.breakpoints.up('sm')]: {
        width: 800,
        height: 800,
        top: -360,
        left: -240,
        opacity: 0.3
    }
}));

const GlowCircle2 = styled(GlowCircle)(({ theme }) => ({
    width: 300,
    height: 300,
    bottom: -120,
    right: -80,
    backgroundColor: 'rgba(55, 71, 79, 0.10)',

    [theme.breakpoints.up('sm')]: {
        width: 800,
        height: 800,
        bottom: -500,
        right: -240
    }
}));
